import {
  GET_ALL_TAGS,
  SET_ADD_EDIT_TAG_MODAL_STATE,
} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';
import store from '../../../store/index';


export const getAllTags = async  ({commit}) => {
  const {success, body} = await axiosClient.get('/api/tag');

  if(success) {
    commit(GET_ALL_TAGS, body);
  }

  return {success, body};
};

export const addNewTag = async ({commit, dispatch}, {tableId, payload, isEditMode}) => {
  const {success, body} = await axiosClient.post(`/api/tag/${tableId}`, payload);
  if(success) {
    isEditMode
      ? await store.dispatch(
        'sidebar/updateTagsList',
        {tableId, data: body},
        {root: true},
      )
      : await store.dispatch(
        'sidebar/addTagToTagsList',
        {tableId, data: body},
        {root: true},
      );
    await dispatch('getAllTags');
  }
  return success;
};

export const deleteTagRelation = async ({commit, dispatch}, {tableId, tagId}) => {
  const {success} = await axiosClient.delete(`/api/tag/tagrelations/${tableId}/${tagId}`);

  if(success) {
    await store.dispatch(
      'sidebar/removeTagFromTagsList',
      {tableId, tagId},
      {root: true},
    );
  }
};

// export const deleteTag = async ({commit, dispatch},   {tableId, tagId}) => {
//   const {success} = await axiosClient.delete(`/api/tag/${tagId}`);
//
//   if(success) {
//     await store.dispatch(
//       'sidebar/removeTagFromTagsList',
//       {tableId, tagId},
//       {root: true},
//     );
//     await dispatch('getAllTags');
//   }
// };

export const setAddEditTagModalState = ({commit}, payload) => {
  commit(SET_ADD_EDIT_TAG_MODAL_STATE, payload);
};